import { Transition } from "@headlessui/react";
import type { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export const SlideTransition = ({
  show,
  animate = true,
  children,
  className,
  parentClass,
}: {
  show: boolean;
  animate?: boolean;
  children: ReactNode;
  className?: string;
  parentClass?: string;
}) => {
  return (
    <Transition
      as={"div"}
      className={twMerge(
        animate && "grid transition-[grid-template-rows]",
        parentClass,
      )}
      show={show}
      enterFrom={twMerge(animate && "grid-rows-[0fr] opacity-0")}
      enterTo={twMerge(animate && "grid-rows-[1fr] opacity-100")}
      leaveFrom={twMerge(animate && "grid-rows-[1fr]")}
      leaveTo={twMerge(animate && "grid-rows-[0fr]")}
    >
      <div className={twMerge("overflow-hidden", className)}>{children}</div>
    </Transition>
  );
};
